import isArray from 'lodash/isArray'
import isPlainObject from 'lodash/isPlainObject'

export const getYearRange = (value, years) => {
  const { min, max } = value
  if (min === 0 && max === years.length) {
    return []
  }
  return years.slice(value.min, value.max)
}

const camelToSnakeCase = camelCasedKey => {
  const snakedKey = camelCasedKey
    .split('')
    .map(character => {
      if (character.toUpperCase().match(/[A-Z]/i) && character === character.toUpperCase()) return `_${character.toLowerCase()}`
      return character
    })
    .join('')

  return snakedKey
}

const snakeToCamelCase = snakeCasedKey => {
  const cameledKey = snakeCasedKey.replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase())
  return cameledKey
}

export const camelCaseToSnakeCase = camelObject => {
  if (isPlainObject(camelObject)) {
    const snakedObject = {}
    Object.keys(camelObject).forEach(camelKey => {
      snakedObject[camelToSnakeCase(camelKey)] = camelCaseToSnakeCase(camelObject[camelKey])
    })
    return snakedObject
  }
  if (isArray(camelObject)) {
    return camelObject.map(arrayEntry => camelCaseToSnakeCase(arrayEntry))
  }
  return camelObject
}

export const snakeCaseToCamelCase = snakedObject => {
  if (isPlainObject(snakedObject)) {
    const cameledObject = {}
    Object.keys(snakedObject).forEach(camelKey => {
      cameledObject[snakeToCamelCase(camelKey)] = snakeCaseToCamelCase(snakedObject[camelKey])
    })
    return cameledObject
  }
  if (isArray(snakedObject)) {
    return snakedObject.map(arrayEntry => snakeCaseToCamelCase(arrayEntry))
  }
  return snakedObject
}

export const notFoundReactQuery = error => {
  if (!error || !error.response || !error.response.errors) return false
  return error.response.errors.filter(e => e.extensions?.code === 'not_found').length > 0
}

const isVowel = char => {
  const vowels = ['a', 'e', 'i', 'o', 'u']
  return vowels.includes(char.toLowerCase())
}

const getArticle = (name = '') => {
  const defaultResult = 'a'
  if (typeof name !== 'string') return defaultResult
  return isVowel(name.substring(0, 1)) ? 'an' : defaultResult
}

export const prefixWordWithArticle = word => `${getArticle(word)} ${word}`

/**
 * Removes undefined values from an object
 * @param obj
 * @returns {{[p: string]: unknown}}
 */
export const removeUndefined = obj => {
  return Object.fromEntries(Object.entries(obj).filter(([key, value]) => value !== undefined))
}
